class API {
  constructor() {
    this.url =
      "https://script.google.com/macros/s/AKfycbxXlzfqWSZw0qEzKoxX9vbokxdcqsy-uCm3DBVefGAXRmnEgMlbsuTKSXJ7W2xX7afIug/exec";
    // "https://script.google.com/macros/s/AKfycbxYOHWr-LXkPiu5gGLzRT1keXUg0h10LT6hBD8HQEhVmMpL3EjgqmHSZiZGKHdvZrEyXw/exec";
    // "https://script.google.com/macros/s/AKfycbxaEPaX0I5xknYqcIz3e9qu2_ZW57XrKgs2-y24IcmdvK7iedQuA3-5NpPQE4WQGI7D/exec";
    // "https://script.google.com/macros/s/AKfycbyqds0fs0lLUb390C2wadRsbPAKoWjX0md-C44xWGVGwcNsJKoCYDyIE4F8-h-qI_DO/exec";
  }

  async push(feedbackData) {
    const data = JSON.stringify(feedbackData);

    return fetch(this.url, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    });
  }
}

export default API;
